export default "__VITE_ASSET__wFDKMtCt__"